import { Component, OnInit } from '@angular/core';
import { EquipmentService, TicketsService } from 'src/app/services'
import { CreateTicketFormFields,SaveBatchTicket,SelectedBatchEquipment } from 'src/app/models/tickets/createTicketFormFields';

@Component({
  selector: 'bart-water-volume',
  templateUrl: './water-volume.component.html',
  styleUrls: ['./water-volume.component.scss']
})
export class WaterVolumeComponent implements OnInit 
{
  public formFields: CreateTicketFormFields;
  public objBatchTicket:SaveBatchTicket;

  public objWaterVolume:WaterVolume[];
  public disabled:boolean=false;
  public errorClass:string="";
  public btnactive="Next";

  public errorHeader:string="";
  public errorContent:string="";
  public displayError:boolean=false;
  public templateHeaderName:string="WATER VOLUME"
  constructor(private _equipmentService: EquipmentService, private _ticketsService: TicketsService) 
  {
    this.formFields = new CreateTicketFormFields();
  }

  ngOnInit() 
  {
    this._ticketsService.getTicketGlobalData().subscribe((Result: any) => 
    {
      this.formFields = Result;
      this.objWaterVolume=this.formFields.selectedBatchEquipmentList;
      let workTypeText:string =this.formFields.selectedWorkTypeName.toString().toLowerCase();
      if(workTypeText=="volume template")
      {
        this.templateHeaderName="Volume"
      }
    },
    (error) => 
    {
      console.log(error);
    }
    );

    
  }
  public btnBackClicked()
  {
    if(this.objWaterVolume!=null)
    {
     for(let obj of this.objWaterVolume)
     {
       obj.waterVolume=null;
       obj.errorClass="";
     }
    }
    this.formFields.showCurrentTemplate=false
  }
 public btnNextClicked()
 {
   var saveOk = this.saveWaterValues(true);
   if(saveOk)
   {
    if(this.objWaterVolume.length>0)
    {
      this.btnactive="Modify";
      this.formFields.isShowBatchLabour=true;
      this.disabled=true;
    }
    else
    {
      this.btnBackClicked();
    }
   }
   else
   {
    this.btnactive="Next";
    this.formFields.isShowBatchLabour=false;
    this.disabled=false;
   }
 }
 public btnModifyClicked()
 {
  this.btnactive="Next";
  this.formFields.isShowBatchLabour=false;
  this.disabled=false;
 }
 public hideErrorDialog()
 {
  this.displayError=false;
 }
 public saveWaterValues(showAlert)
 {
   
    let success:boolean=true;
    let errors:waterValumeErrors[]=[];
    this.formFields.batchTicketObj=[]
    for(let obj of this.objWaterVolume)
    {
      
       let equipmentId=obj.EquipmentID;
       let serialNumber =obj.EquipmentSerialNumber;
       let ret =this. checkWaterVolume(obj);
       if(ret.waterVolumeOk==false)
       {
         errors.push(ret);
       }
    }
    if(errors.length==0)
    {
      for(let obj of this.objWaterVolume)
      {
         this.objBatchTicket=new SaveBatchTicket();
          this.objBatchTicket.equipmentId=obj.EquipmentID
          this.objBatchTicket.waterVolume = obj.waterVolume
          this.formFields.batchTicketObj.push(this.objBatchTicket);
          
      }
    }
    else
    {
      success=false;
      this.formFields.batchTicketObj=null;
      this.errorClass="batchError"
      var errorMsg = '';
      var i = 0;
       for(let x of errors)
       {
        errorMsg += "<div class='errorHeader'>"+x.mainErrorMessage +"</div>";
        for (i=0;i<x.errorMsg.length;i++) 
        {
          errorMsg += x.errorMsg[i] + '<br/>';
        }
       }
       if(showAlert)
       {
         //alert (errorMsg);
         this.errorHeader="Validation Error";
         this.errorContent=errorMsg;
         this.displayError=true;
       }
    }
    return success
 }
public checkWaterVolume(obj:WaterVolume)
{
    let ret:waterValumeErrors = 
    {
      waterVolumeOk:false,
      mainErrorMessage:"",
      errorMsg:[]
    }
    var waterVolumeMin =0;// obj.waterVolumeMin;//This should come from descreate measure but it is same as old application
    var waterVolumeMax =9999; //obj.waterVolumeMax; //parseFloat($('#waterVolumeMax' + equipmentId).val());
    var waterVolume = obj.waterVolume
      
    if (waterVolume == undefined || waterVolume==null || waterVolume.toString().length==0) 
    {
      waterVolume = null;
    }
    else 
    {
      waterVolume =waterVolume;
    }
    
    if (waterVolume == null) 
    {
      ret.errorMsg.push( 'Volume must be entered.');
      ret.waterVolumeOk = false;
    } 
    else if (isNaN(waterVolume)) 
    {
     
      ret.errorMsg.push( 'Volume must be a numeric value.');
      ret.waterVolumeOk = false;
    } 
    else if ( waterVolumeMin!=null && waterVolume < waterVolumeMin) 
    {
      ret.errorMsg.push('Volume is under advised Minimum.');
      ret.waterVolumeOk = false;
    } 
    else 
    if (waterVolume > waterVolumeMax) 
    {
      ret.errorMsg.push('Volume exceeds advised Maximum.');
      ret.waterVolumeOk = false;
    } 
    else 
    {
      ret.waterVolumeOk = true;
    }
    if(ret.waterVolumeOk==false)
    {
      obj.errorClass="batchError"
      ret.mainErrorMessage='Errors found for equipment with serial number ' + obj.EquipmentSerialNumber + '<br/>';
    }
    else
    {
      obj.errorClass="";
    }
    return ret;
  }
 public RemoveRow(equipmentId)
 {
   this.objWaterVolume=this.objWaterVolume.filter(x=>x.EquipmentID!=equipmentId);
   this.formFields.selectedBatchEquipmentList=this.objWaterVolume.filter(x=>x.EquipmentID!=equipmentId);
   if(this.objWaterVolume.length==0)
   {
     this.formFields.isShowBatchLabour = false;
     this.formFields.selectedBatchEquipmentData=[];
    
   }
   if(this.formFields.selectedBatchEquipmentData["EquipmentID"]== equipmentId)
    {
     this.formFields.selectedBatchEquipmentData=[];
    }
 }
}
export class waterValumeErrors
{
  waterVolumeOk:boolean;
  mainErrorMessage:string;
  errorMsg:string[]=[];
}
export class WaterVolume extends SelectedBatchEquipment
{
  
  //Extra Fields
  waterVolume:number=null;
  waterVolumeMax:number=9999;
  waterVolumeMin:number=0;
  errorClass:string="";
}